import { TaggedPitchTypeLabelMap } from '../../../Utils/FilterValueMap';
import zone from '../../../style/images/277415.png'
import { pointRadiusRatio } from './person_configs';

let zoneImage = new Image()
zoneImage.src = zone
export const H2HKZoneConfig2 = {
  plugins: [
    {
      id: 'custom_canvas_zone_image',
      beforeDraw: (chart) => {
        if (zoneImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          // console.log(top, left, width, height)
          var image_rwd_width = window.innerWidth * zoneImage.width / 1920 / 6.4 * 1.35;
          var image_rwd_height = window.innerWidth * zoneImage.height / 1920 / 6.8 * 1.35;
          // console.log(image_rwd_height, image_rwd_width)
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height - image_rwd_height - (20 * window.innerWidth / 1920);
          ctx.drawImage(zoneImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          zoneImage.onload = () => chart.draw();
        }
      }
    },
  ],
  options: {
    responsive: true,  
    aspectRatio: 1,
    maintainAspectRatio: true,
    legend: {
      display: false
    },
    plugins: {
      legend: false,
      tooltip: {
        titleFont: {
          size: pointRadiusRatio(10)
        },
        bodyFont: {
          size: pointRadiusRatio(10)
        },
        padding: pointRadiusRatio(5),
        callbacks: {
          label: (context) => (TaggedPitchTypeLabelMap[context.label]+context.label)
        },
      },
      datalabels: false
    },
    elements: {
      point: {
        pointRadius: pointRadiusRatio(5),
      },
    },
    scales: {
      x: {
        min: -32,
        max: 32,
        ticks: { display: false, stepSize: 5, },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -8,
        max: 58.25,
        ticks: { display: false, stepSize: 5 },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
    } 
  }
}